import { Store } from 'tauri-plugin-store-api';
export interface DesktopToken { token?: string | null }
export const localStore = new Store('.settings.dat');